<template>
  <div class="module-sub-range">
    <div class="module-sub-range-name">{{data.name}}</div>
    <div class="module-sub-range-value">
      <span class="module-sub-range-value-item">{{min}}</span>
      <span>~</span>
      <span class="module-sub-range-value-item">{{max}}</span>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
export default {
  props: {
    data: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  computed: {
    min () {
      if (!_.isNumber(this.data.value[0])) {
        return null
      }
      let unit = ''
      switch (this.data.unit) {
        case 10000:
          unit = '万'
          break
      }
      let v = _.get(this.data, 'value[0]', null)
      if (v === null) {
        return ''
      }
      try {
        return (new Intl.NumberFormat().format(v)) + unit
      } catch (e) {
        return v + unit
      }
    },
    max () {
      if (!_.isNumber(this.data.value[1])) {
        return null
      }
      let unit = ''
      switch (this.data.unit) {
        case 10000:
          unit = '万'
          break
      }
      let v = _.get(this.data, 'value[1]', null)
      if (v === null) {
        return ''
      }
      try {
        return (new Intl.NumberFormat().format(v)) + unit
      } catch (e) {
        return v + unit
      }
    }
  }
}
</script>

<style lang="postcss" scoped>
@import "index.css";
.module-sub-range {
  display: flex;
  @media (--mediaPc) {
    padding: 12px 0;
    margin: 0 53px;
  }
  @media (--mediaMobile) {
    padding-top: calc(24px / var(--scaleMobile) / 2);
    padding-bottom: calc(24px / var(--scaleMobile) / 2);
    padding-left: 40px;
    padding-right: 25px;
  }
  & .module-sub-range-name {
    font-weight: bold;
    @media (--mediaPc) {
      margin-right: 24px;
    }
    @media (--mediaMobile) {
      margin-right: calc(24px / var(--scaleMobile));
    }
  }
  & .module-sub-range-value {
    color: var(--color1);
  }
}
</style>



// WEBPACK FOOTER //
// src/containers/module/sub/Range.vue